import { useRef, useEffect } from 'react';

function useInterval(callback, delay) {
  const latestCallback = useRef(callback);
  useEffect(() => {
    latestCallback.current = callback;
  }, [callback]);
  useEffect(() => {
    if (!delay && delay !== 0) {
      return;
    }
    const id = setInterval(() => {
      if (latestCallback.current() === false) {
        clearInterval(id);
      }
    }, delay);
    return () => clearInterval(id);
  }, [delay]);
}

export { useInterval };
//# sourceMappingURL=use-interval.mjs.map
